<script setup>
import {computed, inject, onMounted, provide, reactive, ref} from "vue";
//import functions
import {required} from "@vuelidate/validators";
import {showMessage} from "@/utils/showMessage.js";
//import components
import {InputText, FloatLabel, Dialog, Select} from "primevue";
import {Icon} from "@iconify/vue";
import PaymentMethods from "@/components/UserProfile/PaymentMethods.vue";
//import stores
import {useUserStore} from "@/stores/user.js";
//import composables
import {useBreakpoint} from "@/composables/useBreakpoint.js";
import {useLoadingFlags} from "@/composables/useLoadingFlags.js";
import {useToast} from "primevue/usetoast";
import {useConfigData} from "@/composables/useConfigData.js";
import {useVuelidate} from "@vuelidate/core";
import {usePaymentMethodsStore} from "@/stores/payment.js";
import AddPaymentMethod from "@/components/UserProfile/AddPaymentMethod.vue";


//stores
const userStore = useUserStore();
const paymentMethodsStore = usePaymentMethodsStore();


//loading flags
const {
  saving,
  setSaving,
  setFetching,
} = useLoadingFlags()

//composables
const {isXL} = useBreakpoint();
const toast = useToast();

//emits
const emit = defineEmits(['refresh']);

//props
const props = defineProps({
  user: {
    type: Object,
    required: true
  }
});

//injects
const visible = inject('isShowPaymentInfoModal')

//component variables
const isShowAddPaymentMethodModal = ref(false)
const methods = ref([]);
const selectedMethod = ref();
const loading = ref(false);
const types = ['Rial', 'Crypto']
const stateColorsMap = {
  New: 'bg-[#9E9E9E]',
  Delivering: 'bg-[#FF9800]',
  Delivered: 'bg-[#2196F3]',
  Canceled: 'bg-[#F44336]',
  Paid: 'bg-[#4CAF50]',
}

const paymentMethod = reactive({
  type: 'Rial'
})


//global functions
//component functions
const onSave = async () => {

}
const selectType = (type) => {
  paymentMethod.type = type
}

const getPaymentMethods = async () => {
  setFetching(true)
  try {
    const res = await paymentMethodsStore.action_getPaymentMethods2({id: props.user.id});
    if (res.result === true) {
      methods.value = res.data
    } else {
      showMessage(res, 'error')
    }
  } catch (err) {
    showMessage(err, 'error')
  } finally {
    setFetching(false)
  }
};
const showAddPaymentMethodModal = (emittedValue) => {
  if (emittedValue.id) {
    selectedMethod.value = emittedValue
  } else {
    selectedMethod.value = null
  }
  isShowAddPaymentMethodModal.value = true
}


//hooks
onMounted(() => {
  getPaymentMethods();
});

//provides
provide('isShowAddPaymentMethodModal', isShowAddPaymentMethodModal)

</script>
<template>
  <Dialog v-model:visible="visible"
          :class="['max-w-3xl !border-0 !rounded-md !bg-[#0e1726]', isXL ? '' : 'w-full']"
          :position="isXL ? 'center' : 'bottom'"
          closable dismissable-mask draggable modal
          content-class="flex flex-col gap-4 overflow-hidden h-full w-full max-w-[calc(100vw-20px)] max-h-[calc(100vh-100px)]">
    <template #header>
      <div class="text-base py-3">
        Payment Methods
      </div>
    </template>
    <template #closebutton="{closeCallback}">
      <div class="h-full w-[1px] bg-slate-700"></div>
      <button
          type="button"
          class="text-white-dark outline-none hover:text-red-500"
          @click="closeCallback"
      >
        <Icon icon="pajamas:close-xs"/>
      </button>
    </template>
    <div class="flex-1 flex flex-col gap-4 overflow-y-auto pt-4 pb-1 text-xs 2xl:text-sm min-w-96 max-w-full">
      <div v-if="methods.length > 0" class="flex flex-col gap-4">
        <PaymentMethods :user="user" :methods="methods" @editMethod="showAddPaymentMethodModal"
                        @refresh="getPaymentMethods"/>
        <button @click="showAddPaymentMethodModal" v-if="methods.length < 2"
                class="btn btn-outline-dark flex items-center justify-center gap-3 disabled:opacity-50 py-1 self-end">
          Add New Payment Method
        </button>
      </div>
      <div v-else class="flex flex-col gap-4 justify-center items-center">
        <p>No payment methods have been added yet.</p>
        <button @click="showAddPaymentMethodModal"
                class="btn btn-outline-dark flex items-center justify-center gap-3 disabled:opacity-50 py-1">
          Add New Payment Method
        </button>
      </div>
    </div>

    <!--    <div class="flex justify-end gap-3 select-none">
          <button @click="onSave"
                  class="btn btn-outline-dark flex items-center justify-center gap-3 disabled:opacity-50 py-1">
            <Icon v-if="saving" icon="eos-icons:bubble-loading" height="24"/>
            Save
          </button>
        </div>-->
  </Dialog>
  <AddPaymentMethod v-if="isShowAddPaymentMethodModal" :user="user" :methods="methods"
                    :selectedMethod="selectedMethod" @refresh="getPaymentMethods"/>
</template>
<style></style>